// extracted by mini-css-extract-plugin
export var backupIcon = "_sw-1";
export var image = "_sw-0";